export function isMapReady(checkStyle = true): boolean {
  // 1. Check if window.map exists AND is an object (catches undefined, null, primitives)
  const mapExists = window.map && typeof window.map === 'object';
  if (!mapExists) {
    // console.warn("isMapReady check failed: window.map is not a valid object.");
    return false;
  }

  // If we only needed to know the object exists (checkStyle is false), we'd return true here.

  if (checkStyle) {
    // 2. CRUCIAL CHECK: Verify 'isStyleLoaded' is specifically a FUNCTION on that object
    const styleCheckPossible = typeof window.map.isStyleLoaded === 'function';
    if (!styleCheckPossible) {
      // This catches cases where window.map is {} or a DOM element, etc.
      // console.warn("isMapReady check failed: window.map.isStyleLoaded is not a function.");
      return false; // It's not the right kind of object!
    }
    // 3. Only call isStyleLoaded() if we know it exists and is a function
    return window.map.isStyleLoaded();
  }

  // If checkStyle was false, and mapExists was true, return true.
  return true;
}
